module.exports = __webpack_public_path__ + "img/docrz.7f21a629.png";